import "./FeaturedLinkBlock.scss";
import { Link, OptimizelyEditProperty } from "/App.Components";
import { getIcon } from "/Components/Icons/IconLookup";
import { FeaturedLinkBlockProps } from "/Models/Generated/FeaturedLinkBlockProps";
import "./FeaturedLinkBlock.scss";

const FeaturedLinkBlock = ({
  link,
  linkPropertyName,
  icon,
}: FeaturedLinkBlockProps) => {
  const Icon = icon ? getIcon(icon) : undefined;
  if (!link && !linkPropertyName) {
    return null;
  }
  return (
    <div className="featured-link-block-norad">
      <OptimizelyEditProperty propertyName={linkPropertyName}>
        {link && (
          <Link
            {...link}
            size="x-small"
            hasUnderline={true}
            icon={Icon ?? undefined}
            iconPlacement="before"
            iconSize="32"
            iconThickness="Light"
            breakWord
          />
        )}
      </OptimizelyEditProperty>
    </div>
  );
};

export default FeaturedLinkBlock;
